import { render, staticRenderFns } from "./MyFooter.vue?vue&type=template&id=6659819c&scoped=true&"
import script from "./MyFooter.vue?vue&type=script&lang=ts&"
export * from "./MyFooter.vue?vue&type=script&lang=ts&"
import style0 from "./MyFooter.vue?vue&type=style&index=0&id=6659819c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6659819c",
  null
  
)

export default component.exports